import { ChangeDetectorRef, Component, NgZone, OnInit } from "@angular/core";
import moment from "moment";
import { Guid } from "typescript-guid";
import { combineDateWithTime } from "../../../../utils/date";
import { FunctionName, FunctionNameName } from "../../models/function-name";
import { TestType } from "../../models/test-type";
import { SharePointStructureCreatorService } from "../../services/sharepoint-structure-creator.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone:false,
  templateUrl: "./script-tester.component.html",
  styleUrls: ["./script-tester.component.scss"],
  providers: [SharePointStructureCreatorService]
})
export class ScriptTesterComponent implements OnInit {
  InputType = TestType;

  isEditorLoading = true;
  editorOptions: monaco.editor.IStandaloneEditorConstructionOptions;
  script: string;
  isTestingScript: boolean;
  output: string;
  outputHasErrors: boolean;

  function = FunctionName.GetLibraryName;
  functionOptions = Object.keys(FunctionName)
    .filter((f) => isNaN(Number(f)))
    .map((f) => ({ label: FunctionNameName.get(FunctionName[f]), value: FunctionName[f] }));
  inputType = TestType.UserInput;
  /** LUA script input parameters */
  name: string;
  createdOnDate: Date;
  createdOnTime: string;
  id: string;
  logicalName: string;

  instanceId: string;
  applyCallback: (script: string) => void;

  constructor(public activeModal: NgbActiveModal, private ngZone: NgZone, private structureCreatorService: SharePointStructureCreatorService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.editorOptions = {
      language: "lua",
      ariaLabel: "Code here; Press Ctrl+B to focus previous element; Press Ctrl+P to focus next element",
      readOnly: false
    };
    this.setInitialInputParameters();
  }

  onMonacoInit(editor: monaco.editor.IStandaloneCodeEditor) {
    this.ngZone.run(() => {
      this.isEditorLoading = false;
      this.cdr.detectChanges();
      // Get previous focusable element
      // eslint-disable-next-line no-bitwise
      editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyB, function () {
        const previous = document.getElementById("function");
        previous?.focus();
      });
      // Get next focusable element
      // eslint-disable-next-line no-bitwise
      editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyP, function () {
        const next = document.getElementById("testButton");
        next?.focus();
      });
    });
  }

  onClose() {
    this.activeModal.close();
  }

  onCancel() {
    this.activeModal.close();
  }

  onApply() {
    this.applyCallback(this.script);
  }

  createdOnChanged(value: string) {
    this.createdOnDate = new Date(value);
  }

  test() {
    this.isTestingScript = true;
    this.outputHasErrors = false;
    const inputData = {
      script: this.script,
      functionName: FunctionNameName.get(this.function),
      input: { name: this.name, createdOn: combineDateWithTime(this.createdOnDate, this.createdOnTime), id: this.id, logicalName: this.logicalName },
      isRealData: this.inputType === TestType.RealData
    };
    this.structureCreatorService.testScript(this.instanceId, inputData).subscribe(
      (response) => {
        if (response.success) {
          this.output = response.data;
        } else {
          this.output = response.error;
          this.outputHasErrors = true;
        }
        this.isTestingScript = false;
      },
      (errorResponse) => {
        this.output = JSON.stringify(errorResponse);
        this.outputHasErrors = true;
        this.isTestingScript = false;
      }
    );
  }

  reset() {
    this.setInitialInputParameters();
  }

  private setInitialInputParameters() {
    this.name = "Connecting Software";
    this.createdOnDate = new Date();
    this.createdOnTime = moment().format("HH:mm");
    this.id = Guid.create().toString();
    this.logicalName = "account";
  }
}
